
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import store from '../../vuex/store'
export default {
components: {
XInput,
XButton,
Group,
Cell,
Alert,
Loading
},
data () {
return {
loadingShow: false,
loadingText: '保存中',
userInfo: {
userName: '',
mobile: '',
code: ''
},
vcodeTime: 0,
msgShow: false,
showClear: false,
warnMsgShow: false,
warnMsg: ''
}
},
mounted () {
store.commit( 'UPDATE_TITLE', '个人信息' )
},
created () {
store.commit( 'UPDATE_SHOW_FOOTER', false )
var _this = this
_this.$ajax.post( _this.ajaxFactory.get( 'showMyInfo' ), {} ).then( function ( response ) {
var result = response.data
_this.userInfo.userName = result.userName
_this.userInfo.mobile = result.mobile
} )
.catch( function ( response ) {
console.log( response )
} )
},
methods: {
getVCode () {
console.log( 'getVode' )
var _this = this

if ( this.vcodeTime <= 0 ) {
if ( _this.validParam() ) {
_this.loadingShow = true
_this.loadingText = '发送中'
_this.$ajax.post( _this.ajaxFactory.get( 'sendSms' ), {}, {
params: _this.userInfo
} ).then( function ( response ) {
_this.loadingShow = false
var result = response.data
if ( result.code === '200' ) {
_this.loadingShow = false
_this.vcodeTime = 60
_this.msg = '已发送'
_this.msgShow = true
_this.vCodeTimer()
} else {
_this.warnMsgShow = true
_this.warnMsg = result.msg
}
} )
.catch( function ( response ) {
_this.loadingShow = false
console.log( response )
} )
}
}
},
vCodeTimer () {
this.vcodeTime--
var _this = this
this.vcodeTime > 0 && setTimeout( function () {
_this.vCodeTimer()
}, 1000 )
},
validParam () {
var _this = this
if ( this.userInfo.userName.name === '' ) {
_this.warnMsgShow = true
_this.warnMsg = '名称不能为空'
return false
}
if ( !this.userInfo.userName.match( '[\\u4e00-\\u9fa5\\da-zA-Z()]{2,40}' ) || this.userInfo.userName.length > 40 ) {
_this.warnMsgShow = true
_this.warnMsg = '名称格式不正确'
return false
}
if ( !this.userInfo.mobile.match( /^1\d{10}$/ ) ) {
_this.warnMsgShow = true
_this.warnMsg = '手机号格式不正确'
return false
}
return true
},
save () {
var _this = this
if ( _this.validParam() ) {
if ( _this.userInfo.code === '' ) {
_this.warnMsgShow = true
_this.warnMsg = '验证码不能为空'
return false
}
_this.loadingShow = true
_this.loadingText = '保存中'
_this.$ajax.post( _this.ajaxFactory.get( 'saveMyInfo' ), {}, {
params: _this.userInfo
} ).then( function ( response ) {
var result = response.data
if ( result.code === '200' ) {
_this.msg = '修改个信息成功'
_this.msgShow = true
setTimeout( function () {
_this.loadingShow = false
window.history.go( -1 )
}, 1500 )
} else {
_this.loadingShow = false
_this.warnMsgShow = true
_this.warnMsg = result.msg
}
} ).catch( function ( response ) {
_this.loadingShow = false
console.log( response )
} )
}
}
},
computed: {
isShowTimer: function () {
return this.vcodeTime > 0
},
isShowBtn: function () {
return this.vcodeTime <= 0
}
}
}



// WEBPACK FOOTER //
// ./src/components/user/xinxi.vue